export const datosAdmin = {
  nombre: 'ORCAS VALLE',
  conexion: 'orcas-valle',
  plataforma: 'https://www.orcas-valle.com',
  enlace: 'https://www.orcas-valle.com?source=qr',
  encargado: 'Willman Barbosa Velasquez',
  cel: '313-739-4026',
  celCorto: '3137394026',
  email: 'esnorcas@hotmail.com',
}

export const departamentosColombia = [
  { dep: "Amazonas", bandera: "https://upload.wikimedia.org/wikipedia/commons/1/1f/Flag_of_Amazonas_(Colombia).svg", codePais: "COL"},
  { dep: "Antioquia", bandera: "https://upload.wikimedia.org/wikipedia/commons/3/33/Flag_of_Antioquia_Department.svg", codePais: "COL"},
  { dep: "Arauca", bandera: "https://upload.wikimedia.org/wikipedia/commons/8/8a/Flag_of_Arauca.svg", codePais: "COL"},
  { dep: "Atlántico", bandera: "https://upload.wikimedia.org/wikipedia/commons/a/a3/Flag_of_Atl%C3%A1ntico.svg", codePais: "COL"},
  { dep: "Bolívar", bandera: "https://upload.wikimedia.org/wikipedia/commons/a/a0/Flag_of_Bol%C3%ADvar_(Colombia).svg", codePais: "COL"},
  { dep: "Boyacá", bandera: "https://upload.wikimedia.org/wikipedia/commons/2/2e/Flag_of_Boyac%C3%A1_Department.svg", codePais: "COL"},
  { dep: "Caldas", bandera: "https://upload.wikimedia.org/wikipedia/commons/e/e2/Flag_of_Caldas.svg", codePais: "COL"},
  { dep: "Caquetá", bandera: "https://upload.wikimedia.org/wikipedia/commons/b/b0/Flag_of_Caquet%C3%A1.svg", codePais: "COL"},
  { dep: "Casanare", bandera: "https://upload.wikimedia.org/wikipedia/commons/b/ba/Flag_of_Casanare.svg", codePais: "COL"},
  { dep: "Cauca", bandera: "https://upload.wikimedia.org/wikipedia/commons/a/ae/Flag_of_Cauca.svg", codePais: "COL"},
  { dep: "Cesar", bandera: "https://upload.wikimedia.org/wikipedia/commons/4/43/Flag_of_Cesar.svg", codePais: "COL"},
  { dep: "Chocó", bandera: "https://upload.wikimedia.org/wikipedia/commons/a/ae/Flag_of_Choc%C3%B3.svg", codePais: "COL"},
  { dep: "Córdoba", bandera: "https://upload.wikimedia.org/wikipedia/commons/9/9b/Flag_of_C%C3%B3rdoba.svg", codePais: "COL"},
  { dep: "Cundinamarca", bandera: "https://upload.wikimedia.org/wikipedia/commons/6/65/Flag_of_Cundinamarca.svg", codePais: "COL"},
  { dep: "Guainía", bandera: "https://upload.wikimedia.org/wikipedia/commons/6/65/Flag_of_Guain%C3%ADa.svg", codePais: "COL"},
  { dep: "Guaviare", bandera: "https://upload.wikimedia.org/wikipedia/commons/9/9b/Flag_of_Guaviare.svg", codePais: "COL"},
  { dep: "Huila", bandera: "https://upload.wikimedia.org/wikipedia/commons/b/b2/Flag_of_Huila.svg", codePais: "COL"},
  { dep: "La Guajira", bandera: "https://upload.wikimedia.org/wikipedia/commons/3/35/Flag_of_La_Guajira.svg", codePais: "COL"},
  { dep: "Magdalena", bandera: "https://upload.wikimedia.org/wikipedia/commons/1/18/Flag_of_Magdalena.svg", codePais: "COL"},
  { dep: "Meta", bandera: "https://upload.wikimedia.org/wikipedia/commons/7/72/Flag_of_Meta.svg", codePais: "COL"},
  { dep: "Nariño", bandera: "https://upload.wikimedia.org/wikipedia/commons/2/20/Flag_of_Nari%C3%B1o.svg", codePais: "COL"},
  { dep: "Norte de Santander", bandera: "https://upload.wikimedia.org/wikipedia/commons/9/9a/Flag_of_Norte_de_Santander.svg", codePais: "COL"},
  { dep: "Putumayo", bandera: "https://upload.wikimedia.org/wikipedia/commons/9/93/Flag_of_Putumayo.svg", codePais: "COL"},
  { dep: "Quindío", bandera: "https://upload.wikimedia.org/wikipedia/commons/2/29/Flag_of_Quind%C3%ADo.svg", codePais: "COL"},
  { dep: "Risaralda", bandera: "https://upload.wikimedia.org/wikipedia/commons/0/02/Flag_of_Risaralda.svg", codePais: "COL"},
  { dep: "San Andrés y Providencia", bandera: "https://upload.wikimedia.org/wikipedia/commons/3/36/Flag_of_San_Andr%C3%A9s_y_Providencia.svg", codePais: "COL"},
  { dep: "Santander", bandera: "https://upload.wikimedia.org/wikipedia/commons/6/6f/Flag_of_Santander_(Colombia).svg", codePais: "COL"},
  { dep: "Sucre", bandera: "https://upload.wikimedia.org/wikipedia/commons/3/39/Flag_of_Sucre_(Colombia).svg", codePais: "COL"},
  { dep: "Tolima", bandera: "https://upload.wikimedia.org/wikipedia/commons/b/b9/Flag_of_Tolima.svg", codePais: "COL"},
  { dep: "Valle del Cauca", bandera: "https://upload.wikimedia.org/wikipedia/commons/d/d3/Flag_of_Valle_del_Cauca.svg", codePais: "COL"},
  { dep: "Vaupés", bandera: "https://upload.wikimedia.org/wikipedia/commons/c/c0/Flag_of_Vaup%C3%A9s.svg", codePais: "COL"},
  { dep: "Vichada", bandera: "https://upload.wikimedia.org/wikipedia/commons/f/fc/Flag_of_Vichada.svg", codePais: "COL"},

  { dep: "Colombia", bandera: "https://upload.wikimedia.org/wikipedia/commons/2/21/Flag_of_Colombia.svg", codePais: "COL", pais: true},
  { dep: "Ecuador", bandera: "https://upload.wikimedia.org/wikipedia/commons/e/e8/Flag_of_Ecuador.svg", codePais: "EC", pais: true}
];

export function pruebasRecords(){
  const auxPruebas = [
    '50 Libre',
    '100 Libre',
    '200 Libre',
    '400 Libre',
    '800 Libre',
    '1500 Libre',

    '50 Espalda',
    '100 Espalda',
    '200 Espalda',

    '50 Pecho',
    '100 Pecho',
    '200 Pecho',

    '50 Mariposa',
    '100 Mariposa',
    '200 Mariposa',

    '100 Combinado Ind.',
    '200 Combinado Ind.',
    '400 Combinado Ind.',
  ];

  return auxPruebas;
}

export const gruposCategorias = [
  {categoria: 'Pre-Menores', edades: [5,6], genero: 'Femenino'},
  {categoria: 'Pre-Menores', edades: [5,6], genero: 'Masculino'},
  {categoria: 'Menores', edades: [7,8,9], genero: 'Femenino'},
  {categoria: 'Menores', edades: [7,8,9], genero: 'Masculino'},
  {categoria: 'Infantil A', edades: [10,11], genero: 'Femenino'},
  {categoria: 'Infantil A', edades: [10,11], genero: 'Masculino'},
  {categoria: 'Infantil B', edades: [12,13], genero: 'Femenino'},
  {categoria: 'Infantil B', edades: [12,13], genero: 'Masculino'},
  {categoria: 'Juvenil A', edades: [14,15], genero: 'Femenino'},
  {categoria: 'Juvenil A', edades: [14,15], genero: 'Masculino'},
  {categoria: 'Juvenil B', edades: [16,17], genero: 'Femenino'},
  {categoria: 'Juvenil B', edades: [16,17], genero: 'Masculino'},
  {categoria: 'Junior', edades: [18,19,20], genero: 'Femenino'},
  {categoria: 'Junior', edades: [18,19,20], genero: 'Masculino'},
];

export const marcasBasePuntos25WA = [
  { genero: "Masculino", pruebas: [
      { prueba: "50 Libre", marcaBase: 20.16 },
      { prueba: "100 Libre", marcaBase: 44.84 },
      { prueba: "200 Libre", marcaBase: 99.37 },
      { prueba: "400 Libre", marcaBase: 212.25 },
      { prueba: "800 Libre", marcaBase: 440.46 },
      { prueba: "1500 Libre", marcaBase: 846.88 },
      { prueba: "50 Espalda", marcaBase: 22.11 },
      { prueba: "100 Espalda", marcaBase: 48.33 },
      { prueba: "200 Espalda", marcaBase: 105.63 },
      { prueba: "50 Pecho", marcaBase: 24.95 },
      { prueba: "100 Pecho", marcaBase: 55.28 },
      { prueba: "200 Pecho", marcaBase: 120.16 },
      { prueba: "50 Mariposa", marcaBase: 21.75 },
      { prueba: "100 Mariposa", marcaBase: 47.78 },
      { prueba: "200 Mariposa", marcaBase: 106.85 },
      { prueba: "100 Combinado Ind.", marcaBase: 49.28 },
      { prueba: "200 Combinado Ind.", marcaBase: 109.63 },
      { prueba: "400 Combinado Ind.", marcaBase: 234.81 },
      { prueba: "4x50 Libre Relevo", marcaBase: 81.80 },
      { prueba: "4x100 Libre Relevo", marcaBase: 182.75 },
      { prueba: "4x200 Libre Relevo", marcaBase: 404.12 },
      { prueba: "4x50 Combinado Relevo", marcaBase: 89.72 },
      { prueba: "4x100 Combinado Relevo", marcaBase: 198.98 },
    ]
  },
  { genero: "Femenino", pruebas: [
      { prueba: "50 Libre", marcaBase: 22.93 },
      { prueba: "100 Libre", marcaBase: 50.25 },
      { prueba: "200 Libre", marcaBase: 110.31 },
      { prueba: "400 Libre", marcaBase: 231.30 },
      { prueba: "800 Libre", marcaBase: 477.42 },
      { prueba: "1500 Libre", marcaBase: 908.24 },
      { prueba: "50 Espalda", marcaBase: 25.25 },
      { prueba: "100 Espalda", marcaBase: 54.89 },
      { prueba: "200 Espalda", marcaBase: 118.94 },
      { prueba: "50 Pecho", marcaBase: 28.37 },
      { prueba: "100 Pecho", marcaBase: 62.36 },
      { prueba: "200 Pecho", marcaBase: 134.57 },
      { prueba: "50 Mariposa", marcaBase: 24.38 },
      { prueba: "100 Mariposa", marcaBase: 54.05 },
      { prueba: "200 Mariposa", marcaBase: 119.61 },
      { prueba: "100 Combinado Ind.", marcaBase: 56.51 },
      { prueba: "200 Combinado Ind.", marcaBase: 121.86 },
      { prueba: "400 Combinado Ind.", marcaBase: 258.94 },
      { prueba: "4x50 Libre Relevo", marcaBase: 92.50 },
      { prueba: "4x100 Libre Relevo", marcaBase: 205.43 },
      { prueba: "4x200 Libre Relevo", marcaBase: 450.87 },
      { prueba: "4x50 Combinado Relevo", marcaBase: 102.35 },
      { prueba: "4x100 Combinado Relevo", marcaBase: 224.35 },
    ]
  }
];

export const marcasBasePuntos50WA = [
  { genero: "Masculino", pruebas: [
      { prueba: "50 Libre", marcaBase: 20.91 },
      { prueba: "100 Libre", marcaBase: 46.40 },
      { prueba: "200 Libre", marcaBase: 102.00 },
      { prueba: "400 Libre", marcaBase: 220.07 },
      { prueba: "800 Libre", marcaBase: 452.12 },
      { prueba: "1500 Libre", marcaBase: 870.67 },
      { prueba: "50 Espalda", marcaBase: 23.55 },
      { prueba: "100 Espalda", marcaBase: 51.60 },
      { prueba: "200 Espalda", marcaBase: 111.92 },
      { prueba: "50 Pecho", marcaBase: 25.95 },
      { prueba: "100 Pecho", marcaBase: 56.88 },
      { prueba: "200 Pecho", marcaBase: 125.48 },
      { prueba: "50 Mariposa", marcaBase: 22.27 },
      { prueba: "100 Mariposa", marcaBase: 49.45 },
      { prueba: "200 Mariposa", marcaBase: 110.34 },
      { prueba: "200 Combinado Ind.", marcaBase: 114.00 },
      { prueba: "400 Combinado Ind.", marcaBase: 242.50 },
      { prueba: "4x100 Libre Relevo", marcaBase: 188.24 },
      { prueba: "4x200 Libre Relevo", marcaBase: 418.55 },
      { prueba: "4x100 Combinado Relevo", marcaBase: 206.78 },
    ]
  },
  { genero: "Femenino", pruebas: [
      { prueba: "50 Libre", marcaBase: 23.61 },
      { prueba: "100 Libre", marcaBase: 51.71 },
      { prueba: "200 Libre", marcaBase: 112.23 },
      { prueba: "400 Libre", marcaBase: 235.38 },
      { prueba: "800 Libre", marcaBase: 484.79 },
      { prueba: "1500 Libre", marcaBase: 920.48 },
      { prueba: "50 Espalda", marcaBase: 26.86 },
      { prueba: "100 Espalda", marcaBase: 57.13 },
      { prueba: "200 Espalda", marcaBase: 123.14 },
      { prueba: "50 Pecho", marcaBase: 29.16 },
      { prueba: "100 Pecho", marcaBase: 64.13 },
      { prueba: "200 Pecho", marcaBase: 137.55 },
      { prueba: "50 Mariposa", marcaBase: 24.43 },
      { prueba: "100 Mariposa", marcaBase: 55.18 },
      { prueba: "200 Mariposa", marcaBase: 121.81 },
      { prueba: "200 Combinado Ind.", marcaBase: 126.12 },
      { prueba: "400 Combinado Ind.", marcaBase: 264.38 },
      { prueba: "4x100 Libre Relevo", marcaBase: 207.96 },
      { prueba: "4x200 Libre Relevo", marcaBase: 457.50 },
      { prueba: "4x100 Combinado Relevo", marcaBase: 229.63 },
    ]
  }
];

export const marcasMinimasInterligas = [
  {categoria: 'Juvenil A', edad: [15], genero: 'Masculino', pruebas: [
    { prueba: '50 Mariposa', marcaMinima: '0:28:97' },
    { prueba: '100 Mariposa', marcaMinima: '1:5:38' },
    { prueba: '200 Mariposa', marcaMinima: '2:41:17' },
    { prueba: '50 Pecho', marcaMinima: '0:34:91' },
    { prueba: '100 Pecho', marcaMinima: '1:19:22' },
    { prueba: '200 Pecho', marcaMinima: '2:55:65' },
    { prueba: '50 Espalda', marcaMinima: '0:32:64' },
    { prueba: '100 Espalda', marcaMinima: '1:22:26' },
    { prueba: '200 Espalda', marcaMinima: '2:34:53' },
    { prueba: '50 Libre', marcaMinima: '0:26:87' },
    { prueba: '100 Libre', marcaMinima: '0:58:85' },
    { prueba: '200 Libre', marcaMinima: '2:10:54' },
    { prueba: '400 Libre', marcaMinima: '4:39:53' },
    { prueba: '800 Libre', marcaMinima: '9:52:3' },
    { prueba: '1500 Libre', marcaMinima: '19:24:88' },
    { prueba: '200 Combinado Ind.', marcaMinima: '2:31:77' },
    { prueba: '400 Combinado Ind.', marcaMinima: '5:32:62' },
  ]},
  {categoria: 'Juvenil A', edad: [16], genero: 'Masculino', pruebas: [
    { prueba: '50 Mariposa', marcaMinima: '0:27:99' },
    { prueba: '100 Mariposa', marcaMinima: '1:3:28' },
    { prueba: '200 Mariposa', marcaMinima: '2:38:16' },
    { prueba: '50 Pecho', marcaMinima: '0:33:92' },
    { prueba: '100 Pecho', marcaMinima: '1:16:31' },
    { prueba: '200 Pecho', marcaMinima: '2:54:94' },
    { prueba: '50 Espalda', marcaMinima: '0:31:55' },
    { prueba: '100 Espalda', marcaMinima: '1:9:83' },
    { prueba: '200 Espalda', marcaMinima: '2:34:32' },
    { prueba: '50 Libre', marcaMinima: '0:26:19' },
    { prueba: '100 Libre', marcaMinima: '0:57:37' },
    { prueba: '200 Libre', marcaMinima: '2:8:20' },
    { prueba: '400 Libre', marcaMinima: '4:38:98' },
    { prueba: '800 Libre', marcaMinima: '9:48:7' },
    { prueba: '1500 Libre', marcaMinima: '19:5:18' },
    { prueba: '200 Combinado Ind.', marcaMinima: '2:28:47' },
    { prueba: '400 Combinado Ind.', marcaMinima: '5:20:59' },
  ]},
  {categoria: 'Juvenil B', edad: [17, 18], genero: 'Masculino', pruebas: [
    { prueba: '50 Mariposa', marcaMinima: '0:27:13' },
    { prueba: '100 Mariposa', marcaMinima: '1:1:4' },
    { prueba: '200 Mariposa', marcaMinima: '2:25:45' },
    { prueba: '50 Pecho', marcaMinima: '0:32:72' },
    { prueba: '100 Pecho', marcaMinima: '1:14:44' },
    { prueba: '200 Pecho', marcaMinima: '2:44:23' },
    { prueba: '50 Espalda', marcaMinima: '0:30:54' },
    { prueba: '100 Espalda', marcaMinima: '1:6:22' },
    { prueba: '200 Espalda', marcaMinima: '2:27:34' },
    { prueba: '50 Libre', marcaMinima: '0:25:70' },
    { prueba: '100 Libre', marcaMinima: '0:55:60' },
    { prueba: '200 Libre', marcaMinima: '2:3:71' },
    { prueba: '400 Libre', marcaMinima: '4:29:5' },
    { prueba: '800 Libre', marcaMinima: '9:30:71' },
    { prueba: '1500 Libre', marcaMinima: '18:24:83' },
    { prueba: '200 Combinado Ind.', marcaMinima: '2:23:11' },
    { prueba: '400 Combinado Ind.', marcaMinima: '5:9:29' },
  ]},
  {categoria: 'Mayores', edad: [19], genero: 'Masculino', pruebas: [
    { prueba: '50 Mariposa', marcaMinima: '0:26:39' },
    { prueba: '100 Mariposa', marcaMinima: '0:58:95' },
    { prueba: '200 Mariposa', marcaMinima: '2:23:37' },
    { prueba: '50 Pecho', marcaMinima: '0:31:70' },
    { prueba: '100 Pecho', marcaMinima: '1:11:11' },
    { prueba: '200 Pecho', marcaMinima: '2:39:14' },
    { prueba: '50 Espalda', marcaMinima: '0:29:44' },
    { prueba: '100 Espalda', marcaMinima: '1:5:10' },
    { prueba: '200 Espalda', marcaMinima: '2:25:50' },
    { prueba: '50 Libre', marcaMinima: '0:24:71' },
    { prueba: '100 Libre', marcaMinima: '0:54:59' },
    { prueba: '200 Libre', marcaMinima: '1:58:85' },
    { prueba: '400 Libre', marcaMinima: '4:23:21' },
    { prueba: '800 Libre', marcaMinima: '9:25:88' },
    { prueba: '1500 Libre', marcaMinima: '18:10:19' },
    { prueba: '200 Combinado Ind.', marcaMinima: '2:21:2' },
    { prueba: '400 Combinado Ind.', marcaMinima: '5:5:19' },
  ]},


  {categoria: 'Juvenil A', edad: [14], genero: 'Femenino', pruebas: [
    { prueba: '50 Mariposa', marcaMinima: '0:33:85' },
    { prueba: '100 Mariposa', marcaMinima: '1:21:52' },
    { prueba: '200 Mariposa', marcaMinima: '3:16:20' },
    { prueba: '50 Pecho', marcaMinima: '0:41:54' },
    { prueba: '100 Pecho', marcaMinima: '1:32:21' },
    { prueba: '200 Pecho', marcaMinima: '3:22:29' },
    { prueba: '50 Espalda', marcaMinima: '0:37:49' },
    { prueba: '100 Espalda', marcaMinima: '1:21:91' },
    { prueba: '200 Espalda', marcaMinima: '2:56:18' },
    { prueba: '50 Libre', marcaMinima: '0:31:38' },
    { prueba: '100 Libre', marcaMinima: '1:7:66' },
    { prueba: '200 Libre', marcaMinima: '2:31:93' },
    { prueba: '400 Libre', marcaMinima: '5:21:53' },
    { prueba: '800 Libre', marcaMinima: '11:3:53' },
    { prueba: '1500 Libre', marcaMinima: '20:59:87' },
    { prueba: '200 Combinado Ind.', marcaMinima: '2:54:64' },
    { prueba: '400 Combinado Ind.', marcaMinima: '6:4:57' },
  ]},
  {categoria: 'Juvenil A', edad: [15], genero: 'Femenino', pruebas: [
    { prueba: '50 Mariposa', marcaMinima: '0:33:5' },
    { prueba: '100 Mariposa', marcaMinima: '1:17:44' },
    { prueba: '200 Mariposa', marcaMinima: '3:3:92' },
    { prueba: '50 Pecho', marcaMinima: '0:41:42' },
    { prueba: '100 Pecho', marcaMinima: '1:32:14' },
    { prueba: '200 Pecho', marcaMinima: '3:19:19' },
    { prueba: '50 Espalda', marcaMinima: '0:35:96' },
    { prueba: '100 Espalda', marcaMinima: '1:21:1' },
    { prueba: '200 Espalda', marcaMinima: '2:55:37' },
    { prueba: '50 Libre', marcaMinima: '0:30:47' },
    { prueba: '100 Libre', marcaMinima: '1:6:65' },
    { prueba: '200 Libre', marcaMinima: '2:27:36' },
    { prueba: '400 Libre', marcaMinima: '5:16:25' },
    { prueba: '800 Libre', marcaMinima: '10:37:38' },
    { prueba: '1500 Libre', marcaMinima: '20:10:21' },
    { prueba: '200 Combinado Ind.', marcaMinima: '2:53:36' },
    { prueba: '400 Combinado Ind.', marcaMinima: '5:50:20' },
  ]},
  {categoria: 'Juvenil B', edad: [16, 17], genero: 'Femenino', pruebas: [
    { prueba: '50 Mariposa', marcaMinima: '0:31:69' },
    { prueba: '100 Mariposa', marcaMinima: '1:12:94' },
    { prueba: '200 Mariposa', marcaMinima: '2:57:86' },
    { prueba: '50 Pecho', marcaMinima: '0:39:34' },
    { prueba: '100 Pecho', marcaMinima: '1:27:7' },
    { prueba: '200 Pecho', marcaMinima: '3:10:19' },
    { prueba: '50 Espalda', marcaMinima: '0:34:60' },
    { prueba: '100 Espalda', marcaMinima: '1:15:98' },
    { prueba: '200 Espalda', marcaMinima: '2:45:53' },
    { prueba: '50 Libre', marcaMinima: '0:29:56' },
    { prueba: '100 Libre', marcaMinima: '1:4:47' },
    { prueba: '200 Libre', marcaMinima: '2:22:8' },
    { prueba: '400 Libre', marcaMinima: '5:4:21' },
    { prueba: '800 Libre', marcaMinima: '10:14:92' },
    { prueba: '1500 Libre', marcaMinima: '19:27:56' },
    { prueba: '200 Combinado Ind.', marcaMinima: '2:42:72' },
    { prueba: '400 Combinado Ind.', marcaMinima: '5:37:86' },
  ]},
  {categoria: 'Mayores', edad: [18], genero: 'Femenino', pruebas: [
    { prueba: '50 Mariposa', marcaMinima: '0:30:99' },
    { prueba: '100 Mariposa', marcaMinima: '1:10:51' },
    { prueba: '200 Mariposa', marcaMinima: '2:56:10' },
    { prueba: '50 Pecho', marcaMinima: '0:38:32' },
    { prueba: '100 Pecho', marcaMinima: '1:25:33' },
    { prueba: '200 Pecho', marcaMinima: '3:8:59' },
    { prueba: '50 Espalda', marcaMinima: '0:33:55' },
    { prueba: '100 Espalda', marcaMinima: '1:14:38' },
    { prueba: '200 Espalda', marcaMinima: '2:44:88' },
    { prueba: '50 Libre', marcaMinima: '0:28:79' },
    { prueba: '100 Libre', marcaMinima: '1:1:77' },
    { prueba: '200 Libre', marcaMinima: '2:16:12' },
    { prueba: '400 Libre', marcaMinima: '4:58:51' },
    { prueba: '800 Libre', marcaMinima: '10:6:77' },
    { prueba: '1500 Libre', marcaMinima: '19:12:10' },
    { prueba: '200 Combinado Ind.', marcaMinima: '2:41:75' },
    { prueba: '400 Combinado Ind.', marcaMinima: '5:33:38' },
  ]},
]


export const marcasMinimasInterclubes = [
  {categoria: 'Juvenil A', edad: [15], genero: 'Masculino', pruebas: [
    { prueba: '50 Mariposa', marcaMinima: '0:29:42' },
    { prueba: '100 Mariposa', marcaMinima: '1:6:90' },
    { prueba: '200 Mariposa', marcaMinima: '2:54:16' },
    { prueba: '50 Pecho', marcaMinima: '0:36:7' },
    { prueba: '100 Pecho', marcaMinima: '1:21:73' },
    { prueba: '200 Pecho', marcaMinima: '3:0:30' },
    { prueba: '50 Espalda', marcaMinima: '0:32:89' },
    { prueba: '100 Espalda', marcaMinima: '1:12:40' },
    { prueba: '200 Espalda', marcaMinima: '2:38:52' },
    { prueba: '50 Libre', marcaMinima: '0:27:2' },
    { prueba: '100 Libre', marcaMinima: '0:59:41' },
    { prueba: '200 Libre', marcaMinima: '2:12:3' },
    { prueba: '400 Libre', marcaMinima: '4:44:56' },
    { prueba: '800 Libre', marcaMinima: '10:19:96' },
    { prueba: '1500 Libre', marcaMinima: '20:10:13' },
    { prueba: '200 Combinado Ind.', marcaMinima: '2:35:0' },
    { prueba: '400 Combinado Ind.', marcaMinima: '5:46:0' },
  ]},
  {categoria: 'Juvenil A', edad: [16], genero: 'Masculino', pruebas: [
    { prueba: '50 Mariposa', marcaMinima: '0:28:27' },
    { prueba: '100 Mariposa', marcaMinima: '1:4:8' },
    { prueba: '200 Mariposa', marcaMinima: '2:44:50' },
    { prueba: '50 Pecho', marcaMinima: '0:34:61' },
    { prueba: '100 Pecho', marcaMinima: '1:18:13' },
    { prueba: '200 Pecho', marcaMinima: '3:1:52' },
    { prueba: '50 Espalda', marcaMinima: '0:32:57' },
    { prueba: '100 Espalda', marcaMinima: '1:11:46' },
    { prueba: '200 Espalda', marcaMinima: '2:37:49' },
    { prueba: '50 Libre', marcaMinima: '0:26:38' },
    { prueba: '100 Libre', marcaMinima: '0:58:28' },
    { prueba: '200 Libre', marcaMinima: '2:9:62' },
    { prueba: '400 Libre', marcaMinima: '4:41:39' },
    { prueba: '800 Libre', marcaMinima: '10:5:17' },
    { prueba: '1500 Libre', marcaMinima: '19:21:71' },
    { prueba: '200 Combinado Ind.', marcaMinima: '2:32:40' },
    { prueba: '400 Combinado Ind.', marcaMinima: '5:33:74' },
  ]},
  {categoria: 'Juvenil B', edad: [17, 18], genero: 'Masculino', pruebas: [
    { prueba: '50 Mariposa', marcaMinima: '0:27:55' },
    { prueba: '100 Mariposa', marcaMinima: '1:2:25' },
    { prueba: '200 Mariposa', marcaMinima: '2:32:63' },
    { prueba: '50 Pecho', marcaMinima: '0:33:41' },
    { prueba: '100 Pecho', marcaMinima: '1:15:36' },
    { prueba: '200 Pecho', marcaMinima: '2:47:40' },
    { prueba: '50 Espalda', marcaMinima: '0:30:95' },
    { prueba: '100 Espalda', marcaMinima: '1:8:55' },
    { prueba: '200 Espalda', marcaMinima: '2:30:25' },
    { prueba: '50 Libre', marcaMinima: '0:25:85' },
    { prueba: '100 Libre', marcaMinima: '0:56:16' },
    { prueba: '200 Libre', marcaMinima: '2:5:29' },
    { prueba: '400 Libre', marcaMinima: '4:32:49' },
    { prueba: '800 Libre', marcaMinima: '9:44:12' },
    { prueba: '1500 Libre', marcaMinima: '19:5:18' },
    { prueba: '200 Combinado Ind.', marcaMinima: '2:24:98' },
    { prueba: '400 Combinado Ind.', marcaMinima: '5:20:59' },
  ]},
  {categoria: 'Mayores', edad: [19], genero: 'Masculino', pruebas: [
    { prueba: '50 Mariposa', marcaMinima: '0:26:79' },
    { prueba: '100 Mariposa', marcaMinima: '1:0:56' },
    { prueba: '200 Mariposa', marcaMinima: '2:29:2' },
    { prueba: '50 Pecho', marcaMinima: '0:32:40' },
    { prueba: '100 Pecho', marcaMinima: '1:13:55' },
    { prueba: '200 Pecho', marcaMinima: '2:48:11' },
    { prueba: '50 Espalda', marcaMinima: '0:30:22' },
    { prueba: '100 Espalda', marcaMinima: '1:7:54' },
    { prueba: '200 Espalda', marcaMinima: '2:29:72' },
    { prueba: '50 Libre', marcaMinima: '0:25:2' },
    { prueba: '100 Libre', marcaMinima: '0:55:25' },
    { prueba: '200 Libre', marcaMinima: '2:1:11' },
    { prueba: '400 Libre', marcaMinima: '4:31:0' },
    { prueba: '800 Libre', marcaMinima: '9:37:44' },
    { prueba: '1500 Libre', marcaMinima: '18:32:45' },
    { prueba: '200 Combinado Ind.', marcaMinima: '2:25:0' },
    { prueba: '400 Combinado Ind.', marcaMinima: '5:11:42' },
  ]},


  {categoria: 'Juvenil A', edad: [14], genero: 'Femenino', pruebas: [
    { prueba: '50 Mariposa', marcaMinima: '0:34:98' },
    { prueba: '100 Mariposa', marcaMinima: '1:23:61' },
    { prueba: '200 Mariposa', marcaMinima: '3:22:20' },
    { prueba: '50 Pecho', marcaMinima: '0:43:33' },
    { prueba: '100 Pecho', marcaMinima: '1:34:93' },
    { prueba: '200 Pecho', marcaMinima: '3:25:86' },
    { prueba: '50 Espalda', marcaMinima: '0:38:44' },
    { prueba: '100 Espalda', marcaMinima: '1:25:10' },
    { prueba: '200 Espalda', marcaMinima: '3:4:20' },
    { prueba: '50 Libre', marcaMinima: '0:31:78' },
    { prueba: '100 Libre', marcaMinima: '1:9:32' },
    { prueba: '200 Libre', marcaMinima: '2:33:94' },
    { prueba: '400 Libre', marcaMinima: '5:30:38' },
    { prueba: '800 Libre', marcaMinima: '11:48:76' },
    { prueba: '1500 Libre', marcaMinima: '22:25:75' },
    { prueba: '200 Combinado Ind.', marcaMinima: '3:0:81' },
    { prueba: '400 Combinado Ind.', marcaMinima: '6:29:42' },
  ]},
  {categoria: 'Juvenil A', edad: [15], genero: 'Femenino', pruebas: [
    { prueba: '50 Mariposa', marcaMinima: '0:34:33' },
    { prueba: '100 Mariposa', marcaMinima: '1:20:99' },
    { prueba: '200 Mariposa', marcaMinima: '3:9:50' },
    { prueba: '50 Pecho', marcaMinima: '0:42:80' },
    { prueba: '100 Pecho', marcaMinima: '1:32:89' },
    { prueba: '200 Pecho', marcaMinima: '3:27:11' },
    { prueba: '50 Espalda', marcaMinima: '0:36:79' },
    { prueba: '100 Espalda', marcaMinima: '1:21:69' },
    { prueba: '200 Espalda', marcaMinima: '3:2:9' },
    { prueba: '50 Libre', marcaMinima: '0:31:0' },
    { prueba: '100 Libre', marcaMinima: '1:7:89' },
    { prueba: '200 Libre', marcaMinima: '2:31:35' },
    { prueba: '400 Libre', marcaMinima: '5:28:33' },
    { prueba: '800 Libre', marcaMinima: '11:27:90' },
    { prueba: '1500 Libre', marcaMinima: '21:46:14' },
    { prueba: '200 Combinado Ind.', marcaMinima: '2:58:3' },
    { prueba: '400 Combinado Ind.', marcaMinima: '6:17:96' },
  ]},
  {categoria: 'Juvenil B', edad: [16, 17], genero: 'Femenino', pruebas: [
    { prueba: '50 Mariposa', marcaMinima: '0:32:33' },
    { prueba: '100 Mariposa', marcaMinima: '1:16:30' },
    { prueba: '200 Mariposa', marcaMinima: '3:8:10' },
    { prueba: '50 Pecho', marcaMinima: '0:39:16' },
    { prueba: '100 Pecho', marcaMinima: '1:27:55' },
    { prueba: '200 Pecho', marcaMinima: '3:13:82' },
    { prueba: '50 Espalda', marcaMinima: '0:35:73' },
    { prueba: '100 Espalda', marcaMinima: '1:17:43' },
    { prueba: '200 Espalda', marcaMinima: '2:50:44' },
    { prueba: '50 Libre', marcaMinima: '0:29:94' },
    { prueba: '100 Libre', marcaMinima: '1:5:32' },
    { prueba: '200 Libre', marcaMinima: '2:23:92' },
    { prueba: '400 Libre', marcaMinima: '5:10:59' },
    { prueba: '800 Libre', marcaMinima: '11:2:82' },
    { prueba: '1500 Libre', marcaMinima: '20:59:87' },
    { prueba: '200 Combinado Ind.', marcaMinima: '2:46:11' },
    { prueba: '400 Combinado Ind.', marcaMinima: '6:4:57' },
  ]},
  {categoria: 'Mayores', edad: [18], genero: 'Femenino', pruebas: [
    { prueba: '50 Mariposa', marcaMinima: '0:32:0' },
    { prueba: '100 Mariposa', marcaMinima: '1:13:34' },
    { prueba: '200 Mariposa', marcaMinima: '3:3:44' },
    { prueba: '50 Pecho', marcaMinima: '0:38:90' },
    { prueba: '100 Pecho', marcaMinima: '1:26:0' },
    { prueba: '200 Pecho', marcaMinima: '3:10:41' },
    { prueba: '50 Espalda', marcaMinima: '0:35:7' },
    { prueba: '100 Espalda', marcaMinima: '1:16:75' },
    { prueba: '200 Espalda', marcaMinima: '2:49:77' },
    { prueba: '50 Libre', marcaMinima: '0:29:33' },
    { prueba: '100 Libre', marcaMinima: '1:3:24' },
    { prueba: '200 Libre', marcaMinima: '2:19:91' },
    { prueba: '400 Libre', marcaMinima: '5:5:1' },
    { prueba: '800 Libre', marcaMinima: '10:32:4' },
    { prueba: '1500 Libre', marcaMinima: '20:10:21' },
    { prueba: '200 Combinado Ind.', marcaMinima: '2:44:90' },
    { prueba: '400 Combinado Ind.', marcaMinima: '5:50:20' },
  ]},
]